import { useEffect, useState } from "react";
import { Crown, Medal } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useT } from "@/lib/i18n";

export default function Leaderboard() {
  const { user } = useAuth();
  const { t } = useT();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/games/leaderboard").then(({ data }) => setRows(data)).catch(() => {}); }, []);

  return (
    <div className="p-4 lg:p-8">
      <h1 className="font-display text-3xl sm:text-4xl font-black mb-2 flex items-center gap-3"><Crown className="w-8 h-8 text-amber-400" /> {t("leaderboard_title")}</h1>
      <p className="text-gray-400 mb-6">{t("leaderboard_sub")}</p>
      <div className="glass rounded-2xl border border-amber-500/20 overflow-hidden">
        {rows.map((r, i) => {
          const me = r.user_id === user?.user_id;
          return (
            <div key={r.user_id} data-testid={`leaderboard-row-${i}`}
              className={`flex items-center justify-between px-5 py-4 border-b border-white/5 ${me ? "bg-amber-500/10" : ""}`}>
              <div className="flex items-center gap-4">
                <span className={`w-8 text-center font-mono font-black ${i === 0 ? "text-amber-400" : i === 1 ? "text-gray-300" : i === 2 ? "text-orange-400" : "text-gray-500"}`}>
                  {i < 3 ? <Medal className="w-5 h-5 inline" /> : `#${i + 1}`}
                </span>
                <div>
                  <p className="font-semibold">{r.name}{me ? " (you)" : ""}</p>
                  <p className="text-xs text-gray-500">Level {r.level}</p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-mono text-amber-300">{r.xp.toLocaleString()} XP</p>
                <p className="text-xs text-gray-500 font-mono">{r.coins.toLocaleString()} coins</p>
              </div>
            </div>
          );
        })}
        {rows.length === 0 && <p className="p-6 text-gray-500">No players yet.</p>}
      </div>
    </div>
  );
}
